export default __webpack_public_path__ + "static/media/drop-padlock.0a455cbb.mp3";